<template>
    <v-row>
        <v-col md="12" class="page-header">
            <h2>
                <span>Alterar Senha</span>
            </h2>
        </v-col>
        <v-col md='12'>
            <v-form v-model="valid" ref="form">
                <v-row>
                    <v-col cols="12" sm="12" md="6" lg="4">
                        <v-text-field
                            outlined
                            prepend-icon="person"
                            :disabled="(this.userLogin != null && this.userLogin != '')"
                            :clearable="(this.userLogin != null && this.userLogin != '')"
                            label="Usuário"
                            :rules="[rules.requiredRules.required]"
                            v-model="currentLogin"
                            id="currentLogin"
                        ></v-text-field>    
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="6" lg="4">
                        <v-text-field
                            outlined
                            prepend-icon="lock"
                            :append-icon="$store.state.showPW ? 'visibility' : 'visibility_off'"
                            @click:append="$store.state.showPW = !$store.state.showPW"
                            :type="$store.state.showPW ? 'text' : 'password'"
                            name="password"
                            ref="password"
                            label="Senha"
                            id="password"
                            v-model="password"
                            clearable
                            :rules="[rules.requiredRules.required]"
                            autocomplete="off"
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="6" lg="4">
                        <v-text-field
                            outlined
                            prepend-icon="lock"
                            :append-icon="$store.state.showPW ? 'visibility' : 'visibility_off'"
                            @click:append="$store.state.showPW = !$store.state.showPW"
                            :type="$store.state.showPW ? 'text' : 'password'"
                            name="newPassword"
                            label="Nova Senha"
                            id="newpassword"
                            v-model="newPassword"
                            clearable
                            :rules="[rules.requiredRules.required]"
                            autocomplete="off"
                            />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="6" lg="4">
                        <v-text-field
                        outlined
                        prepend-icon="lock"
                        :append-icon="$store.state.showPW ? 'visibility' : 'visibility_off'"
                        @click:append="$store.state.showPW = !$store.state.showPW"
                        :type="$store.state.showPW ? 'text' : 'password'"
                        name="passwordConfirm"
                        label="Confirmar nova senha"
                        id="passwordConfirm"
                        v-model="passwordConfirm"
                        v-on:keyup.enter="submit"
                        clearable
                        :rules="[rules.requiredRules.required, rules.requiredRules.matchPassword]"
                        autocomplete="off"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="6" lg="4">
                        <v-btn
                            elevation="0"
                            color="primary"
                            block
                            large
                            outlined
                            rounded 
                            @click="$router.push({ path: '/'})">
                            <v-icon left>mdi-cancel</v-icon>CANCELAR
                        </v-btn>
                        
                        <v-btn
                            @click="submit"
                            color="primary"
                            block
                            large
                            rounded
                            elevation="0"
                            class="mt-4" 
                            ><v-icon left>mdi-check</v-icon>
                            ALTERAR</v-btn>
                    </v-col>
                </v-row>
            </v-form>
                <snackbar
                :text="snackbarMessage"
                    :color="snackbarColor"
                />
        </v-col>
        <v-dialog v-model="dialog" width="400">
            <v-card outlined elevation="4">
                <v-card-title>Aviso</v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-card-text>
                    <div class="text--primary espaco-top" v-html="mensagemRetorno">
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="primary"
                    large
                    outlined
                    rounded class="text-right" @click="close">CONFIRMAR</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import snackbarMixin from "../../mixins/snackbar.mixin";
import userService from '../../services/users.service';

export default {
    mixins: [snackbarMixin],
    data(){
        return {
            valid: false,
            password: '',
            newPassword:'',
            passwordConfirm: '',
            currentLogin: '',
            dialog:false,
            rules: {
                requiredRules: {
                required: value => !!value || 'Campo obrigatório',
                matchPassword: value =>
                    value === this.newPassword || 'Senha está diferente'
                }
            },
            mensagemRetorno: '',
        };
    },
    computed: {
    ...mapGetters('users', ['userLogin'])
    },
    mounted(){
        this.currentLogin = this.userLogin;

        if(this.userLogin == null || this.userLogin == ""){
            if(this.$refs.currentLogin)
                this.$refs.currentLogin.focus();
        } else if (this.$refs.password) {
            this.$refs.password.focus();
        }
    },
    methods:{
        close(){
            this.$router.push({ name : 'login' });
        },
        submit(){
            if (this.$refs.form.validate()) {
                this.$store.state.loading = true;
                    var data = {
                        login: this.currentLogin,
                        senha: this.password,
                        novaSenha: this.newPassword,
                        confirmacaoSenha: this.passwordConfirm
                    };
                    
                    userService.updatePassword(data)
                    .then((res) => {
                        if(res.Status && res.Status == "OK"){
                            console.log(res);
                            this.mensagemRetorno = 'Senha alterada com sucesso.<br/>Favor efetuar o login para acessar o sistema.';
                            this.$store.state.loading = false;
                        } else {
                            this.mensagemRetorno = res.Mensagem;
                            this.$store.state.loading = false;
                        }
                        this.dialog = true;
                    }).catch(error=>{
                        this.$store.state.loading = false;
                        this.showSnackbar(error, 'error');
                    });
               }
        }
    }
}
</script>
<style scoped>

</style>